import React, { Component } from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import { Redirect } from 'react-router-dom';
import {logoutUser} from "../../actions/user_actions";

class Logout extends Component {

    componentDidMount (){
        this.props.logoutUser();
    }



    render() {

        if (this.props.user ===null){
            return <Redirect to="/" />;
        }

        return (
            <div className={"main-dashboard"}>
                <div>
                <div style={{position:'absolute', top:15, left:0, right:0, margin:'auto'}} className="preloader-wrapper small active">
                    <div className="spinner-layer spinner-red-only">
                        <div className="circle-clipper left">
                            <div className="circle"></div>
                        </div>
                        <div className="gap-patch">
                            <div className="circle"></div>
                        </div>
                        <div className="circle-clipper right">
                            <div className="circle"></div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({logoutUser}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/containers/Logout/logout.js